import React from 'react';
import { CircularProgress, Typography, Box } from '@mui/material';

interface LoadingIndicatorProps {
  text: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ text }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" sx={{ height: '100vh' }}>
      <CircularProgress />
      <Typography variant="body1" mt={2}>
        {text}
      </Typography> 
    </Box>
  );
};

export default LoadingIndicator;
